// Source detail router — V3 default (2026-05-09), ?v=4 opt-in to new
// fresh design (2026-05-11), ?v=2 falls back to V2.
//
// V4 is a fresh design built only from documented backend endpoints,
// no V3 reference. Three horizontal strips (identity / metrics /
// action toolbar) + view tabs + main data table. Action toolbar
// opens 6 contextual right-side drawers (Send / Model / Automate /
// Replay / Privacy / Settings). When V4 reaches feature parity the
// default flips and V3 becomes opt-out.

import { useSearchParams } from 'react-router-dom';
import SourceDetailV2Page from './SourceDetailV2Page';
import SourceDetailV3Page from './SourceDetailV3Page';
import SourceDetailV4Page from './SourceDetailV4Page';

export default function SourceDetailRouter(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const v = searchParams.get('v');
  if (v === '2') return <SourceDetailV2Page />;
  if (v === '4') return <SourceDetailV4Page />;
  return <SourceDetailV3Page />;
}
